<template>
  <div>
    <h1>Email satisfaction survey</h1>
    <FileWorking :file="file" />
    <h2>Choose clients</h2>
    <v-checkbox
      v-model="selectedClients"
      v-for="client in modifiedClients"
      :key="client.id"
      :value="client.id"
      @change="updateChanged"
    >
      <template slot="label">
        <span v-if="client.detail">{{client.detail.personal}} &lt;{{client.detail.address}}&gt;</span>
        <span v-if="!client.detail">{{client.name}}</span>
      </template>
    </v-checkbox>
    <v-alert
      :value="!selectedClients.length"
      type="warning"
    >You need to select at least one client. They must also have email addresses set on their address book entry.</v-alert>
    <div v-if="selectedClients.length">
      <v-select
        v-model="reviewSiteId"
        :items="reviewSites"
        label="Select which review site to recommend"
        item-value="id"
        item-text="name"
        outline
        @change="updateChanged"
      />
      <div v-if="satisfactionHtmls">
        <div
          v-for="(satisfactionHtml, index) in satisfactionHtmls"
          :key="index"
          v-html="satisfactionHtml"
          class="ajaxForm"
        />
        <v-expansion-panel v-if="emailSignature">
          <v-expansion-panel-content>
            <template v-slot:header>
              <div>Automatic email signature (click to view)</div>
            </template>
            <v-card>
              <v-card-text>
                <v-alert
                  :value="true"
                  type="info"
                >This email signature will be included on the email. So you do not need to include your own.</v-alert>
                <div v-html="emailSignature.html" />
                <hr />
                <div v-html="emailSignature.htmlWarnings" />
                <hr />
                <div v-html="emailSignature.htmlPromotion" />
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-btn @click="send" large color="info">
          <v-icon>send</v-icon>&#160;Send
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import FileWorking from "@/components/link/FileWorking";
export default {
  name: "Satisfaction",
  metaInfo() {
    return {
      title: "Satisfaction",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    FileWorking
  },
  computed: {
    modifiedClients() {
      if (!this.clients) {
        return undefined;
      }
      return this.clients.map(c => {
        const detail =
          this.details && this.details[c.id] ? this.details[c.id] : undefined;
        return { ...c, detail };
      });
    }
  },
  data() {
    return {
      file: null,
      clients: null,
      details: null,
      selectedClients: [],
      reviewSites: null,
      reviewSiteId: 2,
      emailSignature: null,
      satisfactionHtmls: null
    };
  },
  methods: {
    fetchFile() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.file = response.data;
        });
    },
    fetchClients() {
      nbmlaw
        .get(`/cors/admin/file/files/${this.$route.params.id}/clients/true`)
        .then(response => {
          // console.log(response.data);
          this.clients = response.data;
        });
    },
    fetchPrimaryEmails() {
      this.selectedEmails = [];
      nbmlaw
        .get(`/cors/admin/file/files/${this.$route.params.id}/clients/primary`)
        .then(response => {
          // console.log(response.data);
          this.details = response.data;
          // for (const [key, value] of Object.entries(this.details)) {
          //   this.selectedEmails.push(value.address);
          // }
        });
    },
    fetchReviewSites() {
      nbmlaw.get(`/cors/admin/directory/reviewSites`).then(response => {
        // console.log(response.data);
        this.reviewSites = response.data;
      });
    },
    fetchSatisfactionHtmls() {
      if (this.selectedClients.length) {
        const ids = this.selectedClients.join(".");
        nbmlaw
          .get(
            `/cors/admin/file/files/${this.$route.params.id}/clients/multiple/${ids}/satisfaction/html`,
            {
              params: { reviewsiteid: this.reviewSiteId }
            }
          )
          .then(response => {
            // console.log(response.data);
            this.satisfactionHtmls = response.data;
          })
          .catch(() => {});
      }
    },
    fetchEmailSignature() {
      nbmlaw
        .get(
          `/cors/admin/directory/entities/${this.$keycloak.tokenParsed.entityid}/emailSignature/files/${this.$route.params.id}`
        )
        .then(response => {
          // console.log(response.data);
          this.emailSignature = response.data;
        })
        .catch(() => {});
    },
    updateChanged() {
      this.satisfactionHtmls = null;
      this.fetchSatisfactionHtmls();
    },
    send() {
      if (this.selectedClients.length) {
        const ids = this.selectedClients.join(".");
        nbmlaw
          .put(
            `/cors/admin/file/files/${this.$route.params.id}/clients/multiple/${ids}/satisfaction/send`,
            null,
            { params: { reviewsiteid: this.reviewSiteId } }
          )
          .then(() => {
            // console.log(response.data);
            this.$router.push({
              name: "file",
              params: { id: this.$route.params.id }
            });
          })
          .catch(() => {});
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchFile();
        this.fetchClients();
        this.fetchPrimaryEmails();
      }
    },
    clients: {
      handler() {
        this.selectedClients = this.clients.map(c => c.id);
        this.fetchSatisfactionHtmls();
      }
    }
  },
  created() {
    this.fetchReviewSites();
    this.fetchEmailSignature();
  }
};
</script>
